import { render, staticRenderFns } from "./create-task.vue?vue&type=template&id=1493397d&"
import script from "./create-task.vue?vue&type=script&lang=ts&"
export * from "./create-task.vue?vue&type=script&lang=ts&"
import style0 from "./create-task.vue?vue&type=style&index=0&id=1493397d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports